export default "__VITE_ASSET__CzIvIEwh__"